<template>
  <div class="c-alert">
    <c-icon
      v-if="icon !== ''"
      :type="icon"
      class="_icon"
    />
    <div class="_title">
      {{ title }}
    </div>
    <div
      v-if="action !== null"
      class="_action"
    >
      <c-button
        :href="action.href"
        outlined
        :target="action.target"
        color="primary"
      >
        {{ action.title }}
      </c-button>
    </div>
    <div
      v-else-if="emitAction !== null"
      class="_action"
    >
      <c-button
        outlined
        color="primary"
        @click="$emit('alertClick')"
      >
        {{ emitAction.title }}
      </c-button>
    </div>
  </div>
</template>
<script setup>
import CButton from 'shared/components/CButton.vue';
import CIcon from 'shared/components/CIcon.vue';

defineEmits(['alertClick']);

defineProps({
  icon: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  action: {
    type: Object,
    default: () => null,
  },
  emitAction: {
    type: Object,
    default: () => null,
  },
});
</script>

<style scoped lang="scss">
  .c-alert {
    display: flex;
    align-items: center;
    border: 1px solid map_get($yellow, 'base');
    background: map_get($yellow, 'lighten-5');
    border-radius: 4px;
    padding: 1.2rem 2rem;
    color: map_get($yellow, 'darken-2');
    font-size: 16px;

    ._icon {
      margin-right: 1rem;
    }

    ._action {
      margin-left: 1rem;
    }
  }

</style>
